import React, { useState } from "react";
import VideoBox from "./VideoBox";
import "./Videolink.css";

const VideoLink = props => {
  const [isActive, setIsActive] = useState(false);

  const toggleVideoBox = () => {
    setIsActive(!isActive);
  };

  if (props.link) {
    return (
      <React.Fragment>
        <span className="videoLink" onClick={toggleVideoBox}>
          {props.children}
        </span>
        {isActive ? <VideoBox onExit={toggleVideoBox} link={props.link} /> : ""}
      </React.Fragment>
    );
  }
  return "";
};

export default VideoLink;



// WEBPACK FOOTER //
// ./src/components/Videolink.jsx